import React from "react";

const SmsOutboundEssentialsIcon = () => (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="24" cy="24" r="23.5" fill="#F3F3FF" stroke="#DEDFFF"/>
  <g clipPath="url(#clip0_sms_essentials)">
    <path d="M15 19.8C15 18.1198 15 17.2798 15.327 16.638C15.6146 16.0735 16.0735 15.6146 16.638 15.327C17.2798 15 18.1198 15 19.8 15H28.2C29.8802 15 30.7202 15 31.362 15.327C31.9265 15.6146 32.3854 16.0735 32.673 16.638C33 17.2798 33 18.1198 33 19.8V25.2C33 26.8802 33 27.7202 32.673 28.362C32.3854 28.9265 31.9265 29.3854 31.362 29.673C30.7202 30 29.8802 30 28.2 30H21.6837C21.0597 30 20.7477 30 20.4492 30.0613C20.1844 30.1156 19.9282 30.2055 19.6875 30.3285C19.4162 30.4671 19.1725 30.662 18.6852 31.0518L16.2998 32.9602C15.8837 33.2931 15.6756 33.4595 15.5005 33.4597C15.3483 33.4599 15.2042 33.3906 15.1092 33.2716C15 33.1348 15 32.8684 15 32.3355V19.8Z" stroke="#4548C4" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19 20.5H24M19 24H27" stroke="#EF4068" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_sms_essentials">
      <rect width="24" height="24" fill="white" transform="translate(12 12)"/>
    </clipPath>
  </defs>
</svg>
);

export default SmsOutboundEssentialsIcon;
